/**
 * Computes the estimated ship date for a made-to-order cart line: today plus the
 * line's `deliveryTimeDays`, formatted for display. The day count itself is not
 * shown — we surface the resulting date instead.
 *
 * Returns `undefined` when there is no positive day count, so callers can skip
 * rendering the date clause entirely.
 *
 * `locale` should be the market's `contentfulLocale` so the formatted date
 * matches the language of the surrounding Contentful copy. It falls back to the
 * runtime default when empty — an empty string would make `Intl` throw a
 * `RangeError`.
 */
export const getEstimatedShipDate = (
  days?: number | null,
  locale?: string,
): string | undefined => {
  if (typeof days !== "number" || days <= 0) {
    return undefined;
  }

  const shipDate = new Date();
  shipDate.setDate(shipDate.getDate() + days);

  return new Intl.DateTimeFormat(locale || undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(shipDate);
};
